import { PdfViewerFitMode } from '../../PdfViewer.constants'

import { PDF_VIEWER_PAGE_WIDTH_CSS_VARIABLE } from './usePdfViewerScale.constants'

export function checkIsPageFitMode(fitMode) {
  return fitMode === PdfViewerFitMode.PageFit
}

export function checkIsScaleFitMode(scaleValue) {
  return Object.values(PdfViewerFitMode).includes(scaleValue)
}

export function checkHasElementSize(element) {
  return element.clientWidth > 0 && element.clientHeight > 0
}

export function checkIsContainerSizeChanged({ lastSize, nextSize }) {
  return (
    !lastSize ||
    lastSize.blockSize !== nextSize.blockSize ||
    lastSize.inlineSize !== nextSize.inlineSize
  )
}

export function setPdfViewerPageWidthVariable({ hostElement, pageWidth }) {
  if (hostElement && pageWidth > 0) {
    hostElement.style.setProperty(
      PDF_VIEWER_PAGE_WIDTH_CSS_VARIABLE,
      `${Math.round(pageWidth)}px`
    )
  }
}
